export const boundary = "boundary";
export const polygon = "polygon";
export const geoIds = "geoIds";
export const geoId = "geoId";
export const aoi = "aoi";
export const layers = "layers";
export const scripts = "scripts";
export const map = "map";
export const mainMenu = "mainmenu";
export const statisticsOpen = "statisticsOpen";
export const feature = "feature";
export const features = "features";
export const embed = "embed"; // Set explicitly on the URL to sign-in automatically as anonymous users
export const lang = "lang";
export const fetchJson = "fetchJson";
export const shareId = "shareId"; // Share ID for shared boundaries
export const recipe = "recipe"; // Recipe ID for multicriteria map
export const pluginConfig = "pluginConfig"; // JSON object with plugin layer settings
export const sepalAsset = "sepalAsset";
export const userAsset = "userAsset"; // User asset IDs for sharing

export default {
  boundary,
  polygon,
  geoIds,
  geoId,
  aoi,
  layers,
  scripts,
  map,
  mainMenu,
  statisticsOpen,
  feature,
  features,
  embed,
  lang,
  fetchJson,
  shareId,
  recipe,
  pluginConfig,
  sepalAsset,
  userAsset,
};
